<template>
  <section class="container">
    <div class="btn-group">
      <el-button
        type="primary"
        class="add-btn"
        @click="routerTo(`/store-add`)">新增</el-button>
    </div>

    <table-pagination
      :config="config"
      :datasource="datasource"
      @change-page="handlerPageChange">
      <!-- <el-table-column sl></el-table-column> -->
      <el-table-column
        slot="filter"
        label="图片"
        align="center">
        <template slot-scope="scope">
          <img
            :src="qiniuDomain + scope.row.experience_img"
            style="max-width: 150px; max-height:100px;">
        </template>
      </el-table-column>
      <el-table-column
        slot="action"
        fixed="right"
        label="操作"
        width="285"
        align="center">
        <template slot-scope="scope">
          <div>
            <el-button
              type="success"
              plain
              @click="routerTo(`/store-detail/${scope.row.uuid}`)">详情</el-button>
            <el-button
              type="primary"
              plain
              @click="routerTo(`/store-edit/${scope.row.uuid}`)">编辑</el-button>
            <el-button
              type="danger"
              plain
              @click="handlerDel(scope)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </table-pagination>

    <el-dialog
      :title="dialogType==0? '新增': '编辑'"
      :visible.sync="dialogEdit"
      width="600px">

      <el-form label-width="100px">
        <el-form-item label="标题">
          <el-input v-model="editObject.experience_title"/>
        </el-form-item>
        <el-form-item label="副标题">
          <el-input v-model="editObject.experience_son_title"/>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="editObject.experience_desc"/>
        </el-form-item>
        <el-form-item label="英文标题">
          <el-input v-model="editObject.experience_english_title"/>
        </el-form-item>
        <el-form-item label="英文副标题">
          <el-input v-model="editObject.experience_english_son_title"/>
        </el-form-item>
        <el-form-item label="英文描述">
          <el-input v-model="editObject.experience_english_desc"/>
        </el-form-item>
        <el-form-item label="图片">
          <el-upload
            class="avatar-uploader"
            :action="uploadDomain"
            :data="uploadData"
            :on-success="uploadSuccess"
            :show-file-list="false">
            <img
              v-if="editObject.experience_img"
              :src="qiniuDomain + editObject.experience_img"
              class="avatar">
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"/>
          </el-upload>
        </el-form-item>

        <el-form-item label="banner">
          <el-upload
            class="upload-demo"
            :action="uploadDomain"
            :data="uploadData"
            :on-success="uploadBannerSuccess"
            :show-file-list="false"
            list-type="picture">
            <el-button
              size="small"
              type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <div
            v-for="(item, index) in editObject.banner"
            :key="index"
            class="banner-box">
            <span
              class="icon"
              @click="onRomoveBanner(index)">×</span>
            <img
              :src="qiniuDomain + item.experience_carousel"
              class="banner-img" >
          </div>
        </el-form-item>
      </el-form>

      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="dialogEdit = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSaveClick()">确 定</el-button>
      </span>
    </el-dialog>

  </section>
</template>

<script>
import TablePagination from '@/components/table-pagination';
// import Mixin from '@/mixins/get-qiniu'
import getQiniuInfo from '@/api/api'
import env from '@/configs/env'
import {
  storeList, addStore, editStore, delStore,
} from '@/api/store'

export default {
  data() {
    return {
      uploadDomain: env.uploadDomain,
      uploadData: {
        token: '',
      },
      qiniuDomain: '',
      dialogEdit: false,
      dialogType: 0, //  0-新增、1-编辑
      editObject: { //  根据接口来的命名，不是很喜欢---
        experience_title: '',
        experience_desc: '',
        experience_img: '',
        experience_son_title: '',
        experience_english_title: '',
        experience_english_desc: '',
        experience_english_son_title: '',
        banner: [],
        uuid: '',
      },
      config: {
        // pagination: true,
        size: 5,
        fields: [
          {
            prop: 'experience_title',
            label: '标题',
          },
          {
            prop: 'experience_son_title',
            label: '副标题',
          },
          {
            prop: 'experience_english_title',
            label: '英文标题',
          },
          {
            prop: 'experience_english_son_title',
            label: '英文副标题',
          },
        ],
      },
      datasource: {
        total: 1,
        data: [],
      },
      pageIndex: 1,
    };
  },

  components: {
    TablePagination,
  },

  created() {
    this.network().getQiniuInfo()
    this.network().storeList()
  },
  methods: {
    routerTo(url) {
      this.$router.push({
        path: url,
      })
    },
    // eslint-disable-next-line no-unused-vars
    handlerPageChange(data) {
      this.pageIndex = data.page
      this.network().storeList()
    },
    handlerEdit(data) {
      this.dialogType = 1 // 编辑框
      this.editObject.experience_title = data.row.experience_title
      this.editObject.experience_son_title = data.row.experience_son_title
      this.editObject.experience_desc = data.row.experience_desc
      this.editObject.experience_english_title = data.row.experience_english_title
      this.editObject.experience_english_son_title = data.row.experience_english_son_title
      this.editObject.experience_english_desc = data.row.experience_english_desc
      this.editObject.experience_img = data.row.experience_img
      this.editObject.banner = data.row.banner || []
      this.editObject.uuid = data.row.uuid
      this.dialogEdit = true
    },
    handlerDel(data) {
      this.network().delStore(data.row.uuid)
    },
    openAddDialog() {
      this.dialogType = 0
      this.editObject.experience_title = ''
      this.editObject.experience_son_title = ''
      this.editObject.experience_desc = ''
      this.editObject.experience_english_title = ''
      this.editObject.experience_english_son_title = ''
      this.editObject.experience_english_desc = ''
      this.editObject.experience_img = ''
      this.editObject.banner = []
      this.editObject.uuid = ''
      this.dialogEdit = true
    },
    handlerNavigator(scope) {
      this.$router.push({
        path: `/example-management/example-${scope.row.alias}`,
      });
    },
    uploadSuccess(res) {
      this.editObject.experience_img = res.hash
    },
    uploadBannerSuccess(res) {
      const oBanner = {
        experience_carousel: res.hash,
      }
      this.editObject.banner.push(oBanner)
    },
    onRomoveBanner(index) {
      this.editObject.banner.splice(index, 1)
    },
    event() {
      return {
        onSaveClick: () => {
          //  dialogType: 0-新增、1-编辑
          if (this.dialogType === 0) {
            this.network().addStore()
          } else {
            this.network().editStore()
          }
        },
      }
    },
    network() {
      return {
        getQiniuInfo: async () => {
          const { status, data } = await getQiniuInfo()
          if (status === 200) {
            this.uploadData.token = data.token
            this.qiniuDomain = data.BucketDomain
          }
        },
        storeList: async () => {
          const { status, data } = await storeList({
            page_index: this.pageIndex,
            page_count: this.config.size,
          })
          if (status === 200) {
            this.datasource.total = data.data_count
            this.datasource.data = data.char
          }
        },
        addStore: async () => {
          const { status } = await addStore(this.editObject)
          if (status === 200) {
            this.dialogEdit = false
            this.network().storeList()
          }
        },
        editStore: async () => {
          const { status } = await editStore(this.editObject)
          if (status === 200) {
            this.dialogEdit = false
            this.network().storeList()
          }
        },
        delStore: async (uuid) => {
          const { status } = await delStore({
            uuid,
          })
          if (status === 200) {
            this.dialogEdit = false
            this.network().storeList()
          }
        },
      }
    },
  },
};
</script>

<style scoped>
.btn-group {
  margin-bottom: 20px;
  text-align: right;
}
.add-btn {
    margin-left: auto;
  }
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed #d9d9d9;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .banner-box {
    position: relative;
    margin-right: 20px;
    display: inline-block;
    width: 200px;
    height: 100px;
  }
  .banner-box .icon {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 2;
    width: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 20px;
    cursor: pointer;
  }
  .banner-img {
    width: 200px;
    height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/vuepage/store/list.vue